import { useShopStore } from '@/js/pinia-stores/shop';

export function useMarketplaceShop() {
  const store = useShopStore();

  return {
    shop: store.shop,
    products: store.products,
    eligibility: store.eligibility,
    loadShop: store.loadShop,
    checkEligibility: store.checkEligibility,
    createCommunity: store.createCommunity
  };
}
